import banner from "@/assets/images/banner-gitex.jpg";
import brush from "@/assets/images/brush-gradient.png";
import gitex from "@/assets/images/ens_2025.png";
import LucidMascot from "@/assets/images/lucid-mascot.png";
import Layout from "@/components/elements/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { verifyCaptcha, registrationGitex } from "@/services/api/Master";
import { CircleNotch, Play } from "@phosphor-icons/react";
import Image from "next/legacy/image";
import { useRouter } from "next/router";
import { useCallback, useRef, useState, useEffect } from "react";
import toast from "react-hot-toast";

import RegisterEventSuccess from "@/components/modal/RegisterEventSuccess";
import { useReCaptcha } from "next-recaptcha-v3";
import { Textarea } from "@/components/ui/textarea";
import ReactPlayer from "react-player/lazy";
import videoCover from "@/assets/images/intro-video-cover.jpg";
import { Checkbox } from "@/components/ui/checkbox";

export default function Gitex() {
  const formRef = useRef(null);

  const router = useRouter();
  const [isLoading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [notes, setNotes] = useState("");
  const [company_name, setCompany] = useState("");
  const { executeRecaptcha } = useReCaptcha();
  const [isSuccess, setIsSuccess] = useState(false);
  const [isFeatured, setIsFeatured] = useState(false);
  const [playing, setIsPlaying] = useState(false);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const handlePlayPause = () => {
    setIsPlaying(!playing);
  };

  const handleFeaturedStartup = () => {
    setIsFeatured(!isFeatured);
  };

  const submit = useCallback(
    async (event) => {
      try {
        event.preventDefault();
        setLoading(true);
        await registrationGitex({
          name,
          company_name,
          email,
          role,
          note: notes,
          featured: isFeatured,
          event_name: "Expand North Star 2025",
          from_qr_code: false,
        });
        setIsSuccess(true);
        formRef.current.reset();
        setRole("");
        setNotes("");
        setTimeout(() => {
          setIsSuccess(false);
        }, 4000);
        //   const token = await executeRecaptcha("event_gitex");
        //   const response = await verifyCaptcha(token);
        //   if (response.data.score > 0.5) {
        //     await registrationGitex({
        //       name,
        //       company_name,
        //       email,
        //       role,
        //       event_name: "GITEX Global 2023",
        //       from_qr_code: false,
        //     });
        //     setIsSuccess(true);
        //     setTimeout(() => {
        //       setIsSuccess(false);
        //     }, 4000);
        //   }
      } catch (error) {
        toast.error(
          "An error occured while sending the data. Please try again!"
        );
      } finally {
        setLoading(false);
      }
    },
    [executeRecaptcha, name, email, role, notes, isFeatured, company_name]
  );

  return (
    <Layout title={"Expand North Star 2025 | Lucidity Insights"}>
      <div className='relative'>
        <div className='absolute z-10 w-20 md:w-28 2xl:w-44 aspect-[199/320] scale-x-[-1] rotate-[25deg] top-[48%] lg:top-1/2 -translate-y-[48%] lg:-translate-y-1/2 -translate-x-[6vw] lg:-translate-x-[4vw]'>
          <Image
            src={LucidMascot.src}
            alt=''
            layout={"fill"}
            objectFit={"cover"}
          />
        </div>
        <Image
          src={banner}
          alt=''
          layout={"fill"}
          objectFit={"cover"}
          objectPosition='bottom'
        />
        <div className='relative z-10 flex flex-wrap items-start gap-8 px-4 py-16 mx-auto lg:gap-20 lg:flex-nowrap lg:py-28 max-w-7xl'>
          <div className='w-full text-center lg:flex-1 2xl:max-w-3xl lg:text-left'>
            <h1 className='text-5xl font-semibold leading-none tracking-tight text-white md:text-6xl lg:leading-none lg:text-7xl font-display'>
              Welcome To <br />
              <span className='text-transparent bg-clip-text bg-gradient-to-tr from-yellow-1 to-red-1'>
                Lucidity Insights
              </span> at&nbsp;Expand&nbsp;North&nbsp;Star
            </h1>
            <div className='relative aspect-[672/126] h-16 2xl:h-24 mt-8 mx-auto lg:mx-0'>
              <Image src={gitex} alt='' objectFit='cover' layout='fill' />
            </div>
            <p className='relative inline-block mt-12 text-2xl font-bold tracking-tight lg:mt-10 lg:translate-x-8 font-display -rotate-3'>
              <span className='absolute -translate-y-6 -translate-x-12 aspect-[104/37] h-28'>
                <Image src={brush} alt='' objectFit='cover' layout='fill' />
              </span>
              <span className='relative text-background'>
                Reserve your Spot!
              </span>
            </p>
            <form
              ref={formRef}
              onSubmit={submit}
              className='grid max-w-md grid-cols-12 gap-4 mx-auto mt-12 lg:max-w-xl lg:mx-0'
            >
              <div className='col-span-12 lg:col-span-6 space-y-1.5 text-left'>
                <Label className='text-xs'>Name</Label>
                <Input
                  type='text'
                  required
                  onInput={(evt) => setName(evt.target.value)}
                  className='bg-white/10 hover:bg-white/10 border-white/10'
                />
              </div>
              <div className='col-span-12 lg:col-span-6 space-y-1.5 text-left'>
                <Label className='text-xs' htmlFor='company_name'>
                  Company Name
                </Label>
                <Input
                  type='text'
                  id='company_name'
                  onInput={(evt) => setCompany(evt.target.value)}
                  className='bg-white/10 hover:bg-white/10 border-white/10'
                  required
                />
              </div>
              <div className='col-span-12 lg:col-span-6 space-y-1.5 text-left'>
                <Label className='text-xs'>Role</Label>
                <Select
                  value={role}
                  onValueChange={(value) => setRole(value)}
                  required
                >
                  <SelectTrigger className='bg-white/10 hover:bg-white/10 border-white/10'>
                    <SelectValue placeholder='Select Role' />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value='Founder'>Founder</SelectItem>
                    <SelectItem value='Investor'>Investor</SelectItem>
                    <SelectItem value='I work at a Startup'>
                      I work at a Startup
                    </SelectItem>
                    <SelectItem value="I'm a tech enthusiast">{`I'm a tech enthusiast`}</SelectItem>
                    <SelectItem value='Other'>Other</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <div className='col-span-12 lg:col-span-6 space-y-1.5 text-left'>
                <Label className='text-xs' htmlFor='email'>
                  Email
                </Label>
                <Input
                  type='email'
                  id='email'
                  required
                  onInput={(evt) => setEmail(evt.target.value)}
                  className='bg-white/10 hover:bg-white/10 border-white/10'
                />
              </div>
              <div className='w-full col-span-12 space-y-1.5 text-left'>
                <Label className='text-xs'>Notes (Optional)</Label>
                <Textarea
                  className='bg-white/10 hover:bg-white/10 border-white/10'
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  rows={4}
                />
              </div>
              <div className='col-span-12'>
                <div className='flex items-start gap-2 text-left'>
                  <Checkbox
                    id='featured_start'
                    className='border border-white/10 bg-white/10'
                    onCheckedChange={handleFeaturedStartup}
                  />
                  <Label
                    htmlFor='featured_start'
                    className='font-normal leading-tight cursor-pointer'
                  >
                    I want my startup to be featured on Lucidity Insights
                  </Label>
                </div>
              </div>
              <div className='flex flex-col items-center col-span-12 gap-4'>
                <Button
                  type='submit'
                  size='lg'
                  className='w-full text-base text-white bg-gradient-to-r from-yellow-1 to-red-1'
                  disabled={isLoading}
                >
                  {isLoading && (
                    <CircleNotch
                      weight='bold'
                      className='mr-2 text-lg animate-spin'
                    />
                  )}
                  {isLoading ? "Processing..." : "Submit"}
                </Button>
              </div>
            </form>
          </div>
          <div className='relative order-first w-full lg:order-last lg:flex-1'>
            <span className='absolute w-[102%] h-[102%] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl inset-0 aspect-square bg-gradient-to-tr from-yellow-1 to-red-1'></span>
            {!playing && (
              <button
                onClick={handlePlayPause}
                className={`absolute z-10 top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 inline-flex items-center justify-center w-16 lg:w-20 h-16 lg:h-20 rounded-full border-background bg-gradient-to-tr from-yellow-1 to-red-1 ${
                  playing ? "" : "pulse"
                }`}
              >
                <Play weight='fill' className='text-2xl lg:text-3xl' />
              </button>
            )}
            <div className='relative overflow-hidden shadow-lg rounded-xl'>
              {!playing && (
                <Image
                  src={videoCover}
                  objectFit='cover'
                  layout='fill'
                  alt=''
                />
              )}
              {isClient && (
                <ReactPlayer
                  url={
                    "https://lucidityinsights.s3.eu-west-2.amazonaws.com/static_assets/lcdt-startup-intro-converted.mp4"
                  }
                  width='100%'
                  height='100%'
                  playing={playing}
                  controls={playing}
                  playsinline={true}
                  stopOnUnmount={false}
                  pip
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <RegisterEventSuccess isOpen={isSuccess} setOpen={setIsSuccess} />
    </Layout>
  );
}
